import { LOAD_OPEN_INCIDENT_SUCCESS, LOAD_CLOSE_INCIDENT_SUCCESS, ADD_RESOLUTION_PROPOSAL_ACTION_SUCCESS, SORT_INCIDENTS, ADD_COMMENT_SUCCESS } from "./incidentActionTypes";
import * as commentTypes from './comments/commentTypes';
import * as resolutionProposalActionTypes from './comments/commentResolutionProposalActionTypes';
import _ from "lodash";

export default function incidentReducer(state = [], action) {
    switch (action.type) {
        case LOAD_OPEN_INCIDENT_SUCCESS: {
            // Remove child comments and update parent comments with correct comment type
            return action.logIncident.incidents.map((incident) => {
                const childComments = _(incident.Comments)
                    .remove(c => c.ParentId !== c.CommentId)
                    .orderBy(['ParentId', 'CommentId'], ['asc', 'desc'])
                    .groupBy(c => c.ParentId)
                    .map((comments, parentId) => ({ ParentId: Number(parentId), Comments: comments }))
                    .value();

                if (childComments.length > 0) {
                    let commentIndex;
                    for (let childComment of childComments) {
                        commentIndex = _.findIndex(incident.Comments, ["CommentId", childComment.ParentId]);
                        if (commentIndex >= 0)
                            incident.Comments[commentIndex].CommentType = childComment.Comments[0].CommentType;
                    }
                }
                const latestAction = incident.LatestComment.CommentType;

                incident.Status = incident.Status === 'Closed' ? 'Closed' : incident.Status === 'Open' && (latestAction === commentTypes.RESOLUTION_PROPOSAL
                    || latestAction === commentTypes.COMMENT_TO_CUSTOMER) ? 'New' : (latestAction === commentTypes.RESOLUTION_PROPOSAL_CLOSED
                        || latestAction === commentTypes.RESOLUTION_PROPOSAL_IMPLEMENTED
                        || latestAction === commentTypes.RESOLUTION_PROPOSAL_REJECTED) ? 'Closed' :
                    latestAction === commentTypes.COMMENT_FROM_CUSTOMER ? 'Waiting' : latestAction === commentTypes.RESOLUTION_PROPOSAL_RECEIVED ? 'Open' : incident.Status;

                return incident;
            });
        }
        case LOAD_CLOSE_INCIDENT_SUCCESS: {
            // Remove child comments and update parent comments with correct comment type
            if (action.logIncident.incidents !== undefined && action.logIncident.incidents.length > 0){
                let closed = action.logIncident.incidents.map((incident) => {
                    const childComments = _(incident.Comments)
                        .remove(c => c.ParentId !== c.CommentId)
                        .orderBy(['ParentId', 'CommentId'], ['asc', 'desc'])
                        .groupBy(c => c.ParentId)
                        .map((comments, parentId) => ({ ParentId: Number(parentId), Comments: comments }))
                        .value();
    
                    if (childComments.length > 0) {
                        let commentIndex;
                        for (let childComment of childComments) {
                            commentIndex = _.findIndex(incident.Comments, ["CommentId", childComment.ParentId]);
                            if (commentIndex >= 0)
                                incident.Comments[commentIndex].CommentType = childComment.Comments[0].CommentType;
                        }
                    }
                    const latestAction = incident.LatestComment.CommentType;
                    incident.Status = incident.Status === 'Closed' ? 'Closed' : incident.Status === 'Open' && (latestAction === commentTypes.RESOLUTION_PROPOSAL
                        || latestAction === commentTypes.COMMENT_TO_CUSTOMER) ? 'New' : (latestAction === commentTypes.RESOLUTION_PROPOSAL_CLOSED
                            || latestAction === commentTypes.RESOLUTION_PROPOSAL_IMPLEMENTED
                            || latestAction === commentTypes.RESOLUTION_PROPOSAL_REJECTED) ? 'Closed' :
                        latestAction === commentTypes.COMMENT_FROM_CUSTOMER ? 'Waiting' : latestAction === commentTypes.RESOLUTION_PROPOSAL_RECEIVED ? 'Open' : incident.Status;
                    return incident;
                });
                return [...state, ...closed].filter((v, i, a) => a.findIndex(v2 => (v2.Id === v.Id)) === i).sort((x, y) => { return y.Id - x.Id });
            }
            return state;
        }
        case ADD_RESOLUTION_PROPOSAL_ACTION_SUCCESS:
            return state.map(incident => {
                if (incident.Id === action.payload.incidentId) {
                    incident.LatestComment.CommentType = action.payload.commentType;
                    if (action.payload.action === resolutionProposalActionTypes.IMPLEMENTED || action.payload.action === resolutionProposalActionTypes.REJECTED) {
                        incident.LatestComment.CommentType = commentTypes.RESOLUTION_PROPOSAL_IMPLEMENTED;
                    }
                    const latestAction = incident.LatestComment.CommentType;

                    incident.Status = incident.Status === 'Closed' ? 'Closed' : incident.Status === 'Open' && (latestAction === commentTypes.RESOLUTION_PROPOSAL
                        || latestAction === commentTypes.COMMENT_TO_CUSTOMER) ? 'New' : (latestAction === commentTypes.RESOLUTION_PROPOSAL_CLOSED
                            || latestAction === commentTypes.RESOLUTION_PROPOSAL_IMPLEMENTED
                            || latestAction === commentTypes.RESOLUTION_PROPOSAL_REJECTED) ? 'Closed' :
                        latestAction === commentTypes.COMMENT_FROM_CUSTOMER ? 'Waiting' : latestAction === commentTypes.RESOLUTION_PROPOSAL_RECEIVED ? 'New' : incident.Status;

                    const commentIndex = _.findIndex(incident.Comments, ["CommentId", action.payload.commentId]);
                    if (commentIndex >= 0)
                        incident.Comments[commentIndex].CommentType = action.payload.commentType;
                    if (action.payload.action === resolutionProposalActionTypes.IMPLEMENTED || action.payload.action === resolutionProposalActionTypes.REJECTED) {
                        incident.Comments[commentIndex].CommentType = resolutionProposalActionTypes.CLOSED;
                    }
                }
                return incident;
            });
        case ADD_COMMENT_SUCCESS:
            return state.map(incident => {
                if (incident.Id === action.payload.incidentId) {
                    incident.LatestComment.CommentType = action.payload.commentType;
                    incident.LatestComment.Comment = action.payload.comment;

                    incident.Comments.unshift({
                        CommentId: incident.LatestComment.CommentId + 1,
                        CommentType: action.payload.commentType,
                        Comment: action.payload.comment,
                        ParentId: incident.LatestComment.ParentId,
                        IncidentId: incident.LatestComment.IncidentId,
                        Date: new Date().toDateString(),
                        User: incident.LatestComment.User,
                    })
                    const latestAction = incident.LatestComment.CommentType;
                    incident.Status = incident.Status === 'Closed' ? 'Closed' : incident.Status === 'Open' && (latestAction === commentTypes.RESOLUTION_PROPOSAL
                        || latestAction === commentTypes.COMMENT_TO_CUSTOMER) ? 'New' : (latestAction === commentTypes.RESOLUTION_PROPOSAL_CLOSED
                            || latestAction === commentTypes.RESOLUTION_PROPOSAL_IMPLEMENTED
                            || latestAction === commentTypes.RESOLUTION_PROPOSAL_REJECTED) ? 'Closed' :
                        latestAction === commentTypes.COMMENT_FROM_CUSTOMER ? 'Waiting' : latestAction === commentTypes.RESOLUTION_PROPOSAL_RECEIVED ? 'Open' : incident.Status;

                }
                return incident;
            });
        case SORT_INCIDENTS: {
            const sortBy = action.sort.func ? action.sort.func : action.sort.by;
            const direction = action.sort.direction;

            return _.orderBy(state, [sortBy], [direction]);
        }
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/incidents/incidentReducer.js